document.querySelectorAll('.bloc_sommaire').forEach(function (bloc) {
    const items = bloc.querySelectorAll('.sommaire li[data-target]');
    const contents = bloc.querySelectorAll('.liste_contenus .content[id]');

    if (!items.length || !contents.length) {
        return;
    }

    // Clic : scroll ancré + active immédiat
    items.forEach(function (li) {
        li.addEventListener('click', function () {
            const target = document.getElementById(li.dataset.target);
            if (!target) {
                return;
            }

            target.scrollIntoView({ behavior: 'smooth', block: 'start' });

            items.forEach(function (i) {
                i.classList.remove('active');
            });
            li.classList.add('active');
        });
    });

    // Scroll : active en fonction du contenu visible
    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
                return;
            }

            const matchingLi = bloc.querySelector('.sommaire li[data-target="' + entry.target.id + '"]');
            if (!matchingLi) {
                return;
            }

            items.forEach(function (i) {
                i.classList.remove('active');
            });
            matchingLi.classList.add('active');
        });
    }, {
        root: null,
        rootMargin: '-40% 0px -50% 0px',
        threshold: 0
    });

    contents.forEach(function (content) {
        observer.observe(content);
    });
});